export default __webpack_public_path__ + "img/037446ad8716efebeb22c8077d5f2c5e.svg";